import React from "react";
import Page from "../../finwell/pages/Page";
import { useTranslation } from "react-i18next";

const PublicEvents = () => {
  const { t } = useTranslation();
  return (
    <>
      <Page>
        <div className="container">
          <div className="row">
            <div className="col">
              <section className="error-box">
                <img
                  src="https://cdnstg.training.com/halifax/image/2baee77d-c2c0-4190-8c2a-91cc3248eb6c.svg"
                  alt="inprogress-svg"
                />
                <div className="error-msgs">{t("Coming soon...!")}</div>
              </section>
            </div>
          </div>
        </div>
      </Page>
    </>
  );
};

export default PublicEvents;
